import { render, staticRenderFns } from "./employment-contract-form.vue?vue&type=template&id=8872364a&scoped=true&"
import script from "./employment-contract-form.vue?vue&type=script&lang=js&"
export * from "./employment-contract-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8872364a",
  null
  
)

export default component.exports